<template>
  <AttachmentBalloon
    :date="date"
    :userType="userType"
    :hasBeenRead="hasBeenRead"
  >
    <div :class="$style.container">
      <FlatButton
        v-for="ts in attachment.content.timeSlots"
        :class="[
          $style.label,
          {
            [$style['label--unavailable']]: !isTimeSlotAvailable(ts),
          },
        ]"
        :key="ts.id"
        variant="base"
        disabled
        >{{ timeslotLabel(ts) }}</FlatButton
      >
      <FlatButton
        :class="$style.label"
        rel="noopener"
        variant="base"
        size="medium"
        :disabled="true"
        >別の日程を選ぶ
      </FlatButton>
    </div>
  </AttachmentBalloon>
</template>

<script setup lang="ts">
import FlatButton from '@/components/atoms/FlatButton.vue'
import AttachmentBalloon from '@/components/organisms/ChatMessageList/AttachmentBalloon.vue'
import type { ChatMessageUserType } from '@/components/organisms/ChatMessageList/ChatMessageUserType'
import type { Attachment, TimeSlot } from '@/types/app'
import { format, isBefore } from 'date-fns'
/* eslint import/no-duplicates: 0 */
import { ja } from 'date-fns/locale'

defineProps<{
  date: Date
  userType: ChatMessageUserType
  hasBeenRead: boolean
  attachment: Attachment & { type: 'bookingRequest' }
}>()

const isTimeSlotAvailable = (ts: TimeSlot) =>
  ts.isAvailable && isBefore(new Date(), ts.startsAt)

const timeslotLabel = (ts: TimeSlot) =>
  `${format(ts.startsAt, 'yyyy/MM/dd(E)', {
    locale: ja,
  })} ${format(ts.startsAt, 'HH:mm')} ~ ${format(ts.endsAt, 'HH:mm')}`
</script>

<style module lang="scss">
.container {
  width: fit-content;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.label {
  // FIXME
  // 押せないので disabled 当てて hover とかで押せる感でないようにしたいけど文字を黒くして実際にユーザーに見えるように表示したい
  // FlatButtonStyle で当ててるスタイルの詳細度が高いのでやむを得ず !important してる
  color: $color-text-and-object-high-emphasis !important;

  &--unavailable {
    text-decoration-line: line-through !important;
  }
}
</style>
